import { PQ_KEY_PREFIX } from "./hpkeFormat";

interface SealingKey {
  publicKey: string;
  fingerprint: string;
  tenantId: string;
}

export function connectorKeyFile(legacy: SealingKey, postQuantum?: SealingKey) {
  return {
    public_key: legacy.publicKey,
    fingerprint: legacy.fingerprint,
    tenant_id: legacy.tenantId,
    ...(postQuantum
      ? {
          post_quantum_public_key: postQuantum.publicKey,
          post_quantum_fingerprint: postQuantum.fingerprint,
        }
      : {}),
  };
}

export function preferredConnectorPublicKey(key: {
  public_key: string;
  post_quantum_public_key?: string;
}) {
  if (key.post_quantum_public_key === undefined)
    throw new Error("This stack has no post-quantum connector key");
  if (!key.post_quantum_public_key.startsWith(PQ_KEY_PREFIX))
    throw new Error("Invalid post-quantum public key");
  return key.post_quantum_public_key;
}
